/**
 * 金额格式化工具
 * @param amount 金额数值
 * @param currency 货币符号，默认 $
 * @returns 格式化后的金额字符串，如 $1,234.56 或 ¥1,234.56
 */
export function formatMoney(
  amount: number | string | undefined | null,
  currency: '$' | '¥' = '$'
): string {
  const n = typeof amount === 'string' ? parseFloat(amount) : (amount ?? 0);
  if (isNaN(n)) return `${currency}0.00`;
  return `${currency}${n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/**
 * 金额格式化（不带货币符号）
 * @param amount 金额数值
 * @returns 格式化后的金额字符串，如 1,234.56
 */
export function formatNumber(amount: number | string | undefined | null): string {
  const n = typeof amount === 'string' ? parseFloat(amount) : (amount ?? 0);
  if (isNaN(n)) return '0.00';
  return n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
